// project import
import general from './general';
import menu from './menu';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [menu, general]
};

export default menuItems;
